"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getDefaultTheme = _interopRequireDefault(require("./getDefaultTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = function _default(brandingId, themeName) {
  if (brandingId === 12 || brandingId === 15 || brandingId === 16) {
    return false;
  }
  var theme = themeName || (0, _getDefaultTheme.default)(brandingId);
  return theme.indexOf('sap_fiori') >= 0;
};